import React from "react";
import Tabla from "./Tabla";
import usuario_icon from "../../../assets/vw/svg/usuarios.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

class UsuariosXAplicacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataFiltradas: [],
      aplicaciones: [],
      roles: [],
      cargando: true,
      searchInput: "",
      option: "usuarios",
      dataOriginal: [],
      dataInactivas: [],
      dataInactivasFiltradas: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
      success: false
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(
        process.env.REACT_APP_URL_DTO_BACK + "usuarioxaplicacion?usuario=todos",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      ).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "roles?rol=todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(
        ([
          responseBodyAnuncios,
          responseBodyAplicaciones,
          responseBodyRoles,
        ]) => {
          const activas = responseBodyAnuncios.mensaje.filter((usuario) => {
            return usuario.activo === 1;
          });
          const rolesActivos = responseBodyRoles.mensaje.filter((item) => {
            return item.activo === 1;
          });
          this.setState({
            cargando: false,
            data: activas,
            dataOriginal: responseBodyAnuncios.mensaje,
            aplicaciones: responseBodyAplicaciones.mensaje,
            roles: rolesActivos,
            success: true
          });
        }
      )
      .catch((errorP) => {
        this.setState({
          cargando: false, modal: {
            active: true,
            message: errorP.message,
            success: false
          },
          success: false
        });
        console.error(errorP.stack || errorP);
      });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearch();
      });
    }
  };

  globalSearch = () => {
    let { data, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let dataFiltradas = data.filter((value) => {
        return (
          value.usuario.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.nombreRol.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.app.toString().includes(searchInput.toLowerCase())
        );
      });
      this.setState({ dataFiltradas });
    } else {
      let dataFiltradas = [];
      this.setState({ dataFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { dataInactivas, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let dataInactivasFiltradas = dataInactivas.filter((value) => {
        return (
          value.usuario.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.nombreRol.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.app.toString().includes(searchInput.toLowerCase())
        );
      });
      this.setState({ dataInactivasFiltradas });
    } else {
      let dataInactivasFiltradas = [];
      this.setState({ dataInactivasFiltradas });
    }
  };

  changeOption = (option) => {
    this.setState({ dataInactivas: [], dataInactivasFiltradas: [], dataFiltradas: [] });
    this.setState({ option });
    if (option === "archivo") {
      this.usuariosInactivos(this.state.dataOriginal);
    }
  };

  usuariosInactivos = (data) => {
    const inactivas = data.filter((autenticacion) => {
      return autenticacion.activo === 0;
    });
    this.setState({ dataInactivas: inactivas });
  }


  render() {
    return (
      <>
        <Menu />
        <Modal
          modalInfo={this.state.modal}
          setMostrarModal={(data) => {
            this.setState({ modal: data });
          }}
        />
        {
          this.state.cargando && <Loading />
        }
        <div className={`navegacion`}>
          {this.state.success ? (
            <>
              <div className=" posicionMenu">
                <ul className="d-flex flex-row px-0 my-0">
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("usuarios")}
                  >
                    <div
                      className={`nav-link nav-link-title active ps-0 ${this.state.option === "usuarios" ? " active border_menu" : ""
                        }`}
                    >
                      <img
                        src={usuario_icon}
                        alt="destinatarios"
                        className="icono-menu me-3"
                      />
                      <span className={"nav-link-title-one-word--mobile"} style={{ marginRight: '5px' }}>Usuarios</span>
                      <span className={"nav-link-title-show--mobile"}>por aplicación</span>
                    </div>
                  </li>
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("archivo")}
                  >
                    <div
                      className={`nav-link active ps-0  ${this.state.option === "archivo"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                      Archivo
                    </div>
                  </li>
                </ul>
              </div>
              <div className="row border_vw pt-4 ms-0 mx-0">
                <div className="col-12 p-0 contenedor-table">
                  {this.state.option === "archivo" ? (
                    <TablaArchivo
                      data={
                        this.state.dataInactivasFiltradas &&
                          this.state.dataInactivasFiltradas.length
                          ? this.state.dataInactivasFiltradas
                          : this.state.dataInactivas
                      }
                      aplicaciones={this.state.aplicaciones}
                      roles={this.state.roles}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></TablaArchivo>
                  ) : (
                    <Tabla
                      data={
                        this.state.dataFiltradas &&
                          this.state.dataFiltradas.length
                          ? this.state.dataFiltradas
                          : this.state.data
                      }
                      aplicaciones={this.state.aplicaciones}
                      roles={this.state.roles}
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></Tabla>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {
                !this.state.cargando && <NoInfoScreen />
              }
            </>
          )
          }
        </div>
      </>
    );
  }
}

export default UsuariosXAplicacion;
